<div class="d-flex flex-column bg-login m-0">
    <div class="mt-5 col-md-6 offset-md-3">
        <div class="card">
            <div class="card-header">
                <div class="mx-auto logo-container"></div>
            </div>
            <div class="card-body">
                <div class="d-flex justify-content-center">
                    Service unavailable
                </div>
            </div>
        </div>
    </div>
</div>